import { z } from 'zod';

export const zodInvoiceV2PartySuggestionsQueryParamsSchema = z.object({
  limit: z.number().int().min(1).max(50).optional(),
  query: z.string().trim().optional(),
});

export const zodInvoiceV2PartySuggestionSchema = z.object({
  companyId: z.uuid(),
  name: z.string().nullish(),
});

export const zodInvoiceV2PartySuggestionsResponseSchema = z.object({
  data: z.array(zodInvoiceV2PartySuggestionSchema),
});

export const zodInvoiceV2PartyCompaniesBodySchema = z.object({
  companyIds: z.array(z.uuid()).max(500),
});

export const zodInvoiceV2PartyCompanySchema = z.object({
  companyId: z.uuid(),
  name: z.string(),
});

export const zodInvoiceV2PartyCompaniesResponseSchema = z.object({
  data: z.array(zodInvoiceV2PartyCompanySchema),
});
